import { buildWebUrl } from 'utils/webOrigin';

export const getMagicLink = (company, e) => {
  if (!e.inviteToken) {
    return null;
  }

  return buildWebUrl(`/invite/${e.inviteToken}`, company?.subDomain || '');
};
